import VueCookie from 'vue-cookie';

export default {
    setLoading: (state, payload) => {
        state.loading = payload
    },
    setAuthorized: (state, payload) => {
        state.authorized = payload
    },
    setAuthCookie: (state, payload) => {
        VueCookie.set("BLUE", payload, 1);
        state.authCookie = payload
    },
    deleteAuthCookie: (state, payload) => {
        VueCookie.delete("BLUE");
        state.authCookie = ""
    },
    setLanguageSelected: (state, language) => {
        state.languageSelected = language;
        VueCookie.set("BLUE-LANG", language, { expires: '1Y' });
        state.authCookie = language
    },
    setMember: (state, payload) => {
        state.member = payload
    },
    setAccounts: (state, payload) => {
        state.accounts = payload
    },
    setAccountSelected: (state, payload) => {
        state.accountSelected = payload
    },
    setFees: (state, payload) => {
        state.fees = payload
    },
    setCurrencies: (state, payload) => {
        state.currencies = payload
    },
    setBluAccount: (state, payload) => {
        state.bluAccount = payload
    },
    setUsdtAccount: (state, payload) => {
        state.usdtAccount = payload
    },
    setBtcAccount: (state, payload) => {
        state.btcAccount = payload
    },
    setEthAccount: (state, payload) => {
        state.ethAccount = payload
    },
    setRealtAccount: (state, payload) => {
        state.realtAccount = payload
    },
    setJoinPool: (state, payload) => {
        state.joinPool = payload
    },
    setBluValue: (state,payload) => {
        state.bluValue = payload
    },
    setBtcValue: (state,payload) =>{
        state.btcValue = payload
    },
    setEthValue: (state,payload) =>{
        state.ethValue = payload
    },
    setXemValue: (state,payload) =>{
        state.xemValue = payload
    },
    setZarValue: (state,payload) => {
        state.zarValue = payload
    },
    setEurValue: (state,payload) =>{
        state.eurValue = payload
    },
    setGbpValue: (state,payload) =>{
        state.gbpValue = payload
    },
    setChfValue: (state,payload) =>{
        state.chfValue = payload
    },
    setCnyValue: (state,payload) =>{
        state.cnyValue = payload
    },
    setHkdValue: (state,payload) =>{
        state.hkdValue = payload
    },
    setRasValue: (state,payload) =>{
        state.rasValue = payload
    },
    setCadValue: (state,payload) =>{
        state.cadValue = payload
    },
    setAudValue: (state,payload) =>{
        state.audValue = payload
    },
    setFeeRedeem: (state,payload) =>{
        state.feeRedeem = payload
    },
    setFeePurchase: (state,payload) =>{
        state.feePurchase = payload
    },
    setAssetList: (state,payload) =>{
        state.assetList = payload
    },
    setFundValueBtc: (state,payload) =>{
        state.fundValueBtc = payload
    },

    setUsdtValue: (state,payload) =>{
        state.usdtValue = payload
    },

    

}




// WEBPACK FOOTER //
// ./src/store/mutations.js